import { Link, useNavigate } from 'react-router-dom';

const reviews = [
  {
    name: 'Marcus T.',
    role: 'Verified Buyer',
    text: 'The CSSBuy spreadsheet completely changed how I shop. Every link is verified and the QC tips alone saved me from multiple bad purchases. Cannot recommend this resource enough.',
  },
  {
    name: 'Elena R.',
    role: 'Community Member',
    text: 'I have been using CSSBuy sheets for over a year. This resource hub is the most organized collection I have found — way better than digging through Reddit or Discord.',
  },
  {
    name: 'Jordan K.',
    role: 'Fashion Reseller',
    text: 'As someone who buys in bulk, having all categories in one CSSBuy spreadsheet is a game-changer. The shipping hacks section alone has saved me hundreds.',
  },
  {
    name: 'Sophie L.',
    role: 'New Buyer',
    text: 'Started with zero knowledge about agents. The beginner guide and CSSBuy sheet walkthrough made the whole process feel safe and straightforward. Totally worth bookmarking.',
  },
];

export default function TestimonialSection() {
  const navigate = useNavigate();

  return (
    <section className="relative py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center">
            <i className="ri-verified-badge-line text-2xl text-accent-500"></i>
          </div>
          <p className="text-xs md:text-sm text-accent-700 font-label tracking-widest uppercase mb-3">
            Community Verified
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Real Reviews &amp; Editor Picks
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8">
          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {reviews.slice(0, 2).map((review, idx) => (
              <div key={idx} className="bg-background-50 rounded-2xl p-6 flex flex-col gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-semibold text-accent-800">
                      {review.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-500">{review.role}</p>
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-primary-400"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
              </div>
            ))}
          </div>

          <div className="md:col-span-1">
            <div className="bg-accent-100 rounded-2xl p-6 h-full flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-300 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-accent-800">{reviews[2].name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{reviews[2].name}</p>
                  <p className="text-xs text-foreground-500">{reviews[2].role}</p>
                </div>
              </div>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs text-primary-400"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{reviews[2].text}</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="md:col-span-2">
            <button
              onClick={() => navigate('/article/cssbuy-spreadsheet-guide')}
              className="group relative w-full rounded-2xl overflow-hidden h-[240px] md:h-[280px] cursor-pointer block"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20open%20notebook%20with%20handwritten%20shopping%20notes%20beside%20a%20tablet%20displaying%20colorful%20spreadsheet%20data%20surrounded%20by%20scattered%20polaroid%20photos%20and%20a%20steaming%20ceramic%20coffee%20mug%20on%20a%20rich%20walnut%20wood%20desk%20warm%20morning%20sunlight%20streaming%20diagonally%20creating%20long%20gentle%20shadows%20cozy%20productive%20workspace%20aesthetic%20with%20creative%20organized%20chaos%20lifestyle%20blogger%20photography%20style%20with%20soft%20natural%20tones&width=900&height=560&seq=testimonial-card-v3&orientation=landscape"
                alt="CSSBuy Spreadsheet Guide Article"
                title="CSSBuy Spreadsheet 2026: The Definitive Beginner Roadmap"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent rounded-2xl" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-background-50 font-heading text-lg md:text-xl font-bold leading-tight">
                  CSSBuy Sheet 2026: The Definitive Beginner Roadmap
                </p>
                <p className="text-background-200 text-xs mt-2">Everything you need to start shopping with confidence — from finding the right spreadsheet to placing your first order.</p>
                <span className="inline-flex items-center gap-1 text-primary-300 text-xs mt-3 border-b border-primary-400/50 pb-0.5">
                  Read Full Guide <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </button>
          </div>

          <div className="md:col-span-1 flex flex-col gap-5">
            <div className="bg-background-50 rounded-2xl p-5 flex-1 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-secondary-800">{reviews[3].name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{reviews[3].name}</p>
                  <p className="text-xs text-foreground-500">{reviews[3].role}</p>
                </div>
              </div>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs text-primary-400"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{reviews[3].text}</p>
              <div className="mt-auto pt-2">
                <Link to="/" className="text-xs text-accent-600 hover:text-accent-700 border-b border-accent-300 pb-0.5">
                  &larr; Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}